import React, { useMemo, useRef } from 'react';
import './css/index.scss';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';
import styles from './css/index.module.scss';
import TableCell from '../../../../components/TableCell';
import DotsIcon from '../../../../assets/formIcons/dots.svg';
import BlockIcon from '../../../../assets/formIcons/block.svg';
import RefreshIcon from '../../../../assets/formIcons/refresh.svg';
import DeleteIcon from '../../../../assets/formIcons/delete.svg';
import ChangeOrgIcon from '../../../../assets/formIcons/changeOrg.svg';
import ChangePhotosIcon from '../../../../assets/formIcons/photosSmall.svg';
import useComponentVisible from '../../../../helpers/hooks/useComponentVisible';
import useEventCardPhoto from '../../../../helpers/hooks/useEventCardPhoto';
import { EVENT_MODAL_STATES, EVENT_SOURCE_LABELS } from '../../constants';

function Field({ label, value, grey = false, multiline = false, wide = false }) {
  const displayValue = value != null && String(value).trim() !== '' ? value : '—';

  return (
    <div className={classNames(styles.field, { [styles.fieldWide]: wide })}>
      <span className={styles.fieldLabel}>{label}</span>
      <span className={classNames(styles.fieldValue, { [styles.textGrey]: grey, [styles.multiline]: multiline })}>
        {displayValue}
      </span>
    </div>
  );
}

function formatSource(source) {
  if (!source) return '—';
  return EVENT_SOURCE_LABELS[source] || source;
}

function formatStatus(isActive) {
  if (isActive === true) return 'Активно';
  if (isActive === false) return 'Забанено';
  return '—';
}

function EventItem({
  item, setSelectedEvent, setModalState, setIsModalVisible,
}) {
  const cardRef = useRef(null);
  const { profile } = useSelector((store) => store.account);
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  const shouldShowDots = useMemo(
    () => profile?.access_codes?.includes('canEditEvents') || profile?.access_codes?.includes('canFullyDelete'),
    [profile],
  );

  const photoUrl = useEventCardPhoto(item._id, item, cardRef);

  const onEventClick = () => {
    window.open(`/events/single-view?id=${item._id}`, '_blank');
  };

  const onPopupItemClick = (state) => (ev) => {
    ev.stopPropagation();
    setSelectedEvent(item);
    setModalState(state);
    setIsModalVisible(true);
    setIsComponentVisible(false);
  };

  const onEditClick = (ev) => {
    ev.stopPropagation();
    window.open(`/events/edit?id=${item._id}`, '_blank');
  };

  const onEditPhotosClick = (ev) => {
    ev.stopPropagation();
    window.open(`/events/edit-photos?id=${item._id}`, '_blank');
  };

  return (
    <div
      ref={cardRef}
      className={classNames(styles.item, { [styles.dashed]: !item.is_active })}
    >
      <div className={styles.header}>
        <div className={styles.headerLeft} onClick={onEventClick}>
          {photoUrl ? (
            <img className={styles.photo} src={photoUrl} alt="Фото мероприятия" />
          ) : (
            <div className={styles.photoPlaceholder}>Нет фото</div>
          )}
        </div>

        <div className={styles.headerMain}>
          <Field label="Название" value={item.name} />
          <Field label="Источник" value={formatSource(item.source)} />
          <Field label="Статус" value={formatStatus(item.is_active)} />
        </div>

        <div className={styles.headerRight}>
          {shouldShowDots ? (
            <TableCell
              isIcon
              onClick={(ev) => {
                ev.stopPropagation();
                setIsComponentVisible(true);
              }}
            >
              <img src={DotsIcon} alt=":" />
            </TableCell>
          ) : <div />}
          <Field label="Дата создания" value={moment(item.createdAt).format('DD.MM.YYYY HH:mm')} grey />
          <Field label="ID мероприятия" value={item._id} grey />
        </div>
      </div>

      <div className={styles.grid}>
        <Field label="Страна" value={item.country?.name} />
        <Field label="Город" value={item.city?.name} />
        <Field label="Адрес" value={item.address} />
        <Field label="Дата проведения" value={item.holding_date} />
        <Field label="Категория афиши" value={item.events_category?.name || 'Без категории'} />
        <Field label="Специализация" value={item.specialization} />
        <Field label="Email владельца" value={item.user?.email} />
        <Field label="Дата регистрации владельца" value={item.user?.createdAt ? moment(item.user.createdAt).format('DD.MM.YYYY') : '—'} />
        <Field label="ID владельца" value={item.user?._id} grey />
        <Field
          label="Описание"
          value={item.description}
          multiline
          wide
        />
      </div>

      <div ref={ref} className={`table_popup ${isComponentVisible && 'visible'}`}>
        {(profile?.access_codes?.includes('canEditEvents')) && (
          <>
            {item.is_active ? (
              <div className="table_popup_item" onClick={onPopupItemClick(EVENT_MODAL_STATES.block)}>
                <img src={BlockIcon} alt="" />
                <p>Забанить мероприятие</p>
              </div>
            ) : (
              <div className="table_popup_item" onClick={onPopupItemClick(EVENT_MODAL_STATES.makeActive)}>
                <img src={RefreshIcon} alt="" />
                <p>Разбанить мероприятие</p>
              </div>
            )}
            <div className="table_popup_item" onClick={onEditClick}>
              <img src={ChangeOrgIcon} alt="" />
              <p>Изменить данные</p>
            </div>
            <div className="table_popup_item" onClick={onEditPhotosClick}>
              <img src={ChangePhotosIcon} alt="" />
              <p>Изменить фото</p>
            </div>
          </>
        )}
        {profile?.access_codes?.includes('canFullyDelete') && (
          <div className="table_popup_item" onClick={onPopupItemClick(EVENT_MODAL_STATES.fullyDelete)}>
            <img src={DeleteIcon} alt="" />
            <p>Удалить полностью</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default EventItem;
